// extracted by mini-css-extract-plugin
export default {"wrapper":"SkillList_wrapper__nQXKm","toggle":"SkillList_toggle__0PZUc","list":"SkillList_list__0NNv7"};